import ApiService from "@/services/api.service"

/// *** Marketing Service *** ///

export const MarketingService = {
  addToGroup(group_id, patient_ids) {
    return ApiService.post(`marketing/group/${group_id}/add`, { patient_ids: patient_ids })
  },
  removeFromGroup(group_id, patient_ids) {
    return ApiService.post(`marketing/group/${group_id}/remove`, { patient_ids: patient_ids })
  },
  recountGroup(group_id) {
    return ApiService.post(`marketing/group/${group_id}/recount`)
  },
  launchSending(marketing_mailing_id) {
    return ApiService.post(`marketing/mailing/${marketing_mailing_id}/start`)
  },
  stopSending(marketing_mailing_id) {
    return ApiService.post(`marketing/mailing/${marketing_mailing_id}/stop`)
  },
  resumeSending(marketing_mailing_id) {
    return ApiService.post(`marketing/mailing/${marketing_mailing_id}/resume`)
  },
  cloneMailing(marketing_mailing_id) {
    return ApiService.post(`marketing/mailing/${marketing_mailing_id}/clone`)
  },
  resendNotification(notification_id) {
    return ApiService.post(`marketing/notification/${notification_id}/resend`)
  },
  createStandardNotifications() {
    return ApiService.post(`marketing/notification/standard/copy`)
  },
  readNotifications(ids) {
    return ApiService.post(`marketing/notification/read`, { ids: ids }, {}, { loader: false })
  },
  getNotificationChannels() {
    return ApiService.get(`marketing/notification/channels`)
  },
  sendDeferredMessage(data) {
    return ApiService.post(`marketing/notification/deferred/send`, data, {'Content-Type': 'multipart/form-data'})
  },
  submitGiftApplication(data) {
    return ApiService.post(`gift/form`, data)
  },
}
